import { useEffect } from 'react';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';
import GtmEvents from '../constants/gtmEvents';
import findAssociatedLabel from '../utils/findAssociatedLabel';

function useGtmCheckboxTracking() {
  useEffect(() => {
    const handleChange = (e: Event) => {
      if (!(e.target instanceof HTMLInputElement)) {
        return;
      }
      if (e.target.type !== 'checkbox') {
        return;
      }
      const label = findAssociatedLabel(e.target);

      if (e.target.dataset.customTracking && !(e instanceof CustomEvent)) {
        triggerGoogleTagManagerCustomEvent(GtmEvents.CHECKBOX_CLICK, {
          action: 'intent',
          label,
          old_state: e.target.checked ? 'enabled' : 'disabled',
          ...(e.target.dataset.psaId && { psaId: e.target.dataset.psaId }),
        });
        return;
      }

      triggerGoogleTagManagerCustomEvent(GtmEvents.CHECKBOX_CLICK, {
        action: 'change',
        label,
        new_state: e.target.checked ? 'enabled' : 'disabled',
        ...(e.target.dataset.psaId && { psaId: e.target.dataset.psaId }),
      });
    };

    document.addEventListener('change', handleChange, { capture: true });
    return () => document.removeEventListener('change', handleChange, { capture: true });
  }, []);
}

export default useGtmCheckboxTracking;
